import { c as _c } from "react/compiler-runtime";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { TokensService } from "@services/integrations-service/tokens-service";
import { createContext, useContext, useMemo } from "react";
const TokensServiceContext = createContext(undefined);

/**
 * @returns an instance of the tokens service.
 * A context provider is needed to be able to use a single instance of
 * the tokens service in the application. Since the tokens service is
 * stateful and stores the state of ongoing integration authorizations
 * it's better to have a single instance.
 */
export function TokensServiceProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new TokensService({
      coreApiClient: faroCoreApiClient
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const tokensService = t1;
  let t2;
  if ($[1] !== children) {
    t2 = <TokensServiceContext.Provider value={tokensService}>{children}</TokensServiceContext.Provider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}

/**
 * Custom hook to consume the tokens service context.
 * @returns an instance of the tokens service.
 */
export function useTokensService() {
  const context = useContext(TokensServiceContext);
  if (!context) {
    throw Error("useTokensService must be used within the TokensServiceProvider");
  }
  return context;
}